import { render } from "./detail.vue?vue&type=template&id=b195e7ce&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=b195e7ce&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b195e7ce"],['__file',"src/views/food/order/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b195e7ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b195e7ce', __exports__)) {
    console.log('reload')
    api.reload('b195e7ce', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=b195e7ce&scoped=true", () => {
    console.log('re-render')
    api.rerender('b195e7ce', render)
  })

}


export default __exports__